import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import smart from '@/smart/js'
import ImageGallery from '@/components/ImageGallery'

Vue.config.productionTip = false
Vue.use(smart);


Vue.component('image-gallery', ImageGallery)


smart.registerComponents()

require('@/smart/css/smart-base.css')
require('@/smart/css/smart-style.css')
require('./css/style.css')


const vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

window.$vue = vue;
